import { Col, Image, Row } from 'antd'
import React, { useState } from 'react'
import "./quiz.css"
import { CheckCircleFilled } from "@ant-design/icons"

const answerColors = [
    ["#E21B3C", "#6E1C3B"],
    ["#1368CE", "#213973"],
    ["#D89E00", "#9F7500"],
    ["#26890C", "#254427"],
]

export default function Quiz({ question, img, answers, correctMessage, onCorrect, onWrong }) {
    const [resultMessage, setResultMessage] = useState(null);
    const [corrected, setCorrected] = useState(null);
    
    return <div style={{ padding: 5 }}>
        <div className='quiz-question'>
            {question}
            {img && <Image style={{ maxHeight: 100, maxWidth: "90%" }} src={img}/>}
        </div>
        <Row gutter={30}>
            {answers.map((answer, index) => <Col style={{ position: "relative" }} span={12} key={answer.message}>
                <div className='quiz-answer' onClick={() => {
                    if (corrected !== null) return;
                    if (answer.correct) {
                        setResultMessage({
                            correct: true,
                            message: correctMessage || "Bạn đã trả lời đúng!"
                        });
                        setCorrected(index);
                        onCorrect && onCorrect(index);
                    } else {
                        setResultMessage({
                            correct: false,
                            message: "Bạn trả lời sai mất rồi!"
                        })
                        onWrong && onWrong();
                    }
                }} style={{ 
                    backgroundColor: answerColors[index][0],
                    borderColor: answerColors[index][1]
                }}>
                    {answer.message}
                    {answer.img && <Image style={{ maxHeight: 100, maxWidth: "90%" }} src={answer.img}/>}
                </div>
                {(corrected !== null) && (index === corrected) && <div style={{
                    position: "absolute",
                    top: "50%",
                    right: 30,
                    transform: "translateY(-50%)",
                    fontSize: 20,
                    color: "green",
                    backgroundColor: "#afffa4",
                    padding: "0px 5px",
                    borderRadius: "50%",
                }}>
                    <CheckCircleFilled />
                </div>}
            </Col>)
            }
        </Row>
        {resultMessage && <div className="quiz-result" style={{
            color: resultMessage.correct ? "#01d617" : "#7a0101",
            backgroundColor: resultMessage.correct ? "#f0ffef" : "rgb(255, 80, 80)",
            borderColor: resultMessage.correct ? "#01d617" : "#7a0101",
        }}>
            {resultMessage.message}
        </div>}
    </div>
}
